// extracted by mini-css-extract-plugin
export default {"page-wrapper":"styles_page-wrapper__YVjzI","footerContent":"styles_footerContent__YBC+6","ssr-layout":"styles_ssr-layout__3snu-","footer":"styles_footer__XN8mF"};